webpackJsonp([8],{

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _CalculatorInput = __webpack_require__(85);

var _CalculatorInput2 = _interopRequireDefault(_CalculatorInput);

var _Responsive = __webpack_require__(25);

var _Utils = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NetWorthCalculator = function (_React$Component) {
  _inherits(NetWorthCalculator, _React$Component);

  _createClass(NetWorthCalculator, null, [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(NetWorthCalculator, props), document.getElementById(id));
    }
  }, {
    key: 'renderDetails',
    value: function renderDetails() {
      return _react2.default.createElement(
        'div',
        { className: 'net-worth-calculator-description' },
        _react2.default.createElement(
          'h3',
          null,
          'Net Worth Calculator'
        ),
        _react2.default.createElement(
          'h4',
          null,
          'Methodology'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The Net Worth Calculator was created so you can determine your approximate net worth, and determine what net worth percentile you fall into. Input your total assets (aka all of your stuff -- cars, house, investment portfolios, etc.) and your liabilities (aka all of your debts -- student loan debt, credit card debt, home loan debt), to calculate your total net worth (assets minus liabilities) and your net worth bracket based on the 2016 dollar cutoff.'
        )
      );
    }
  }]);

  function NetWorthCalculator() {
    _classCallCheck(this, NetWorthCalculator);

    var _this = _possibleConstructorReturn(this, (NetWorthCalculator.__proto__ || Object.getPrototypeOf(NetWorthCalculator)).call(this));

    _this.state = {
      totalAssets: '',
      totalLiabilities: '',
      netWorth: '',
      percentileBracket: ''
    };
    _this.calculateResults = _this.calculateResults.bind(_this);
    _this.calculateNetWorthBracket = _this.calculateNetWorthBracket.bind(_this);
    return _this;
  }

  _createClass(NetWorthCalculator, [{
    key: 'calculateNetWorthBracket',
    value: function calculateNetWorthBracket(netWorth) {
      var percentiles = ['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '95%', '99%'];
      var cutoffs2016 = [-962.66, 4798.06, 18753.84, 49132.21, 97225.55, 169550.64, 279554.27, 499263.50, 1182390.36, 2377985.22, 10374030.10];

      for (var cutoff = cutoffs2016.length - 1; cutoff >= 0; cutoff -= 1) {
        if (netWorth >= cutoffs2016[cutoff]) {
          return percentiles[cutoff];
        }
      }
      return '10%';
    }
  }, {
    key: 'calculateResults',
    value: function calculateResults() {
      var totalAssets = Number(this.state.totalAssets);
      var totalLiabilities = Number(this.state.totalLiabilities);
      var netWorth = totalAssets - totalLiabilities;

      this.setState({
        netWorth: (0, _Utils.formatNumber)(netWorth.toFixed(2)),
        percentileBracket: this.calculateNetWorthBracket(netWorth)

      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'container net-worth-calculator-container' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-md-2 col-md-offset-1 net-worth-calculator-inputs' },
            _react2.default.createElement(
              _Responsive.LargeMobile,
              null,
              NetWorthCalculator.renderDetails()
            ),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'TOTAL ASSETS',
              value: this.state.totalAssets,
              onChange: function onChange(totalAssets) {
                return _this2.setState({ totalAssets: totalAssets });
              },
              type: 'monetary'
            }),
            _react2.default.createElement(_CalculatorInput2.default, {
              title: 'TOTAL LIABILITIES',
              value: this.state.totalLiabilities,
              onChange: function onChange(totalLiabilities) {
                return _this2.setState({ totalLiabilities: totalLiabilities });
              },
              type: 'monetary'
            }),
            _react2.default.createElement('span', { className: 'divider' }),
            _react2.default.createElement(
              'button',
              { onClick: this.calculateResults },
              ' Calculate '
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-md-7 col-md-offset-1 net-worth-calculator-right-col' },
            _react2.default.createElement(
              _Responsive.Desktop,
              null,
              NetWorthCalculator.renderDetails()
            ),
            _react2.default.createElement(
              'div',
              { className: 'net-worth-calculator-results-container' },
              _react2.default.createElement('div', { className: 'caret' }),
              _react2.default.createElement(
                'div',
                { className: 'net-worth-calculator-results-wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'net-worth-calculator-results' },
                  _react2.default.createElement(_CalculatorInput2.default, {
                    title: 'NET WORTH',
                    value: this.state.netWorth,
                    type: 'monetary',
                    disabled: true
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'net-worth-calculator-results' },
                  _react2.default.createElement(_CalculatorInput2.default, {
                    title: 'NET WORTH BRACKET',
                    value: this.state.percentileBracket,
                    type: 'percent',
                    disabled: true
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NetWorthCalculator;
}(_react2.default.Component);

exports.default = NetWorthCalculator;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _NetWorthCalculator = __webpack_require__(445);

var _NetWorthCalculator2 = _interopRequireDefault(_NetWorthCalculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.NetWorthCalculator = _NetWorthCalculator2.default;

/***/ })

},[466]);


// WEBPACK FOOTER //
// seo-net-worth-calculator.js